import { Product } from '@nemuru-eng/js-api-client';

export const LoanProduct = {
  CONSUMER_LOAN: Product.CONSUMER_LOAN,
  AUTO_LOAN: Product.AUTO,
  CREDIT_LINE: Product.CREDIT_LINE,
  CARD: Product.CARD,
};
